import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/course-templates',
        component: () => import('@/pages/course-templates/CourseTemplates.vue'),
        children: [
            {
                name: 'course-templates',
                path: '',
                component: () => import('@/pages/course-templates/CourseTemplateList.vue'),
                meta: {
                    title: 'Course Templates',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view all course templates'),
                },
            },

            {
                name: 'course-templates-archive',
                path: 'archive',
                component: () => import('@/pages/course-templates/CourseTemplateList.vue'),
                meta: {
                    title: 'Archived Course Templates',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('archive a course template'),
                },
            },
        ],
    },
    {
        name: 'course-template-create',
        path: '/course-templates/create',
        component: () => import('@/pages/course-templates/CourseTemplateCreate.vue'),
        meta: {
            title: 'Create Course Template',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('create a course template'),
        },
    },
    {
        path: '/course-templates/:id',
        component: () => import('@/pages/course-templates/CourseTemplate.vue'),
        props: true,
        children: [
            {
                name: 'course-template-view',
                path: '',
                component: () => import('@/pages/course-templates/CourseTemplateView.vue'),
                meta: {
                    title: 'Course Template',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a course template'),
                },
            },
            {
                name: 'course-template-edit',
                path: 'edit',
                redirect: { name: 'course-template-edit-content' },
                meta: {
                    title: 'Edit Course Template',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('edit a course template'),
                },
            },
            {
                name: 'course-template-edit-content',
                path: 'edit/content',
                component: () => import('@/pages/course-templates/CourseTemplateEdit.vue'),
                meta: {
                    title: 'Edit Course Template Content',
                    middleware: [GateKeeperMiddleware],
                    ability: [{ action: 'edit', subject: 'course template' }],
                },
            },
            {
                name: 'course-template-edit-settings',
                path: 'edit/settings',
                component: () => import('@/pages/course-templates/CourseTemplateEdit.vue'),
                meta: {
                    title: 'Edit Course Template Settings',
                    middleware: [GateKeeperMiddleware],
                    ability: [{ action: 'edit', subject: 'course template' }],
                },
            },
            {
                name: 'course-template-edit-grading-scheme',
                path: 'edit/grading-scheme',
                component: () => import('@/pages/course-templates/CourseTemplateEdit.vue'),
                meta: {
                    title: 'Edit Course Template Grading Scheme',
                    middleware: [GateKeeperMiddleware],
                    ability: [{ action: 'edit', subject: 'course template' }],
                },
            },
            {
                name: 'course-template-edit-schedule',
                path: 'edit/schedule',
                component: () => import('@/pages/course-templates/CourseTemplateEdit.vue'),
                meta: {
                    title: 'Edit Course Template',
                    middleware: [GateKeeperMiddleware],
                    ability: [
                        { action: 'edit', subject: 'course template' },
                        { action: 'edit', subject: 'time period template' },
                    ],
                },
            },
            {
                name: 'course-template-edit-remediation',
                path: 'edit/remediation',
                component: () => import('@/pages/course-templates/CourseTemplateEdit.vue'),
                meta: {
                    title: 'Remediation',
                    middleware: [GateKeeperMiddleware],
                    ability: [{ action: 'edit', subject: 'course template' }],
                },
            },
            {
                name: 'course-template-edit-automated-surveys',
                path: 'edit/evaluations',
                component: () => import('@/pages/course-templates/CourseTemplateEdit.vue'),
                meta: {
                    title: 'Evaluations',
                    middleware: [GateKeeperMiddleware],
                    ability: [{ action: 'edit', subject: 'course template' }],
                },
            },
            {
                name: 'course-template-gradebook-preview',
                path: '/course-templates/:id/gradebook-preview',
                component: () => import('@/pages/gradebook-preview/GradebookPreview.vue'),
                props: route => ({
                    id: Number.parseInt(route.params.id, 10),
                }),
                meta: {
                    title: 'Course Template',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a gradebook preview'),
                },
            },

            {
                name: 'course-template-view-objective',
                path: '/course-templates/:id/objectives/:objectiveId',
                component: () => import('@/pages/courses/objectives/Objective.vue'),
                props: true,
                meta: {
                    title: 'Course Objectives',
                    dataTablePage: true,
                },
            },
        ],
    },
];
